import img1 from "../assets/services/1ElectricalServices.jpg";

const services = [
  {
    id: 1,
    title: "DESIGN & EPC SOLUTIONS",
    image: "https://www.sunvinss.com/admin/upload/TR service.jpg", //
    description: `We provide engineering & EPC solutions to substation, transmission line & distribution systems which are backed up by our huge well diversified product range. For the items which are not covered within our manufacturing range, we have bridged the gap by cultivating a number of partnerships with suppliers across the globe.`,
  },
  {
    id: 2,
    title: "Deputation of Technical Manpower Services",
    image: "https://www.sunvinss.com/admin/upload/Annual Maintanance.jpg", //
    description: `We organize Manpower resources such as Technicians, Engineers and Managers to improve quality and process for the Process plant, Power plants and Substation.`,
  },
  {
    id: 3,
    title:"O & M",
    image:"https://www.sunvinss.com/admin/upload/Operation and Maintance.jpg",
    description:`EAVER facilitates manpower to Project contractors by sourcing Technicians to Managers to work under different power plants and sub stations for operation and maintenance services.`,
  },
  {
    id: 4,
    title: "Testing & Commissioning",
    image: "https://www.sunvinss.com/admin/upload/T&C.jpg", //
    description: `EAVER engages in rendering service in Testing and Commissioning related to Substations, Power Plants, Infrastructures, Industries, and etc. We have experience related to Transmission & Distribution upto 400KV, Power Sectors, Industries and other utilities by way of Detailed Engineering, Testing & Commissioning and Operation & Maintenance. Our services waves from Field services, Instrumentation services and basic engineering services.

    We can manage the work as their entity as under:

    • Testing & Commissioning of Electrical Equipments up to 400KV.

    • Relay Testing using specialized OMICRON CMC – 256-356 / DOBLE Relay Test Set.

    • Detailed Engineering – Structural, Civil & Electrical

    • Operation & Maintenance of Instrumentation, & Electrical Equipments of various Power Plants, Nuclear Plant, Process Plants, Substations & Switchyards.

    • Annual Maintenance Contracts for various utilities such as cement plants, sugar plants, process industries etc.`,
  },
  {
    id: 5,
    title: "Eelectrical Installation",
    image: "https://www.sunvinss.com/admin/upload/Substation-Installation-Works.jpg", 
    description: `
    EAVER does the installation and maintenance of electrical equipments and takes over Control & Instrumentation Works for

    • Power Plants - Thermal, Gas, Combined Cycle, Nuclear, & Hydel

    • Substation up to 400 kV

    • Fertilizer, Petrochemical & Chemical Plants

    • Refineries and Oil & Gas installations

    • Desalination Plants

    • Cement Plants

    • Other Industrial Plants like Sugar, Paper & Pulp.`,
  },
  {
    id: 6,
    title: "IT / Software Development",
    image: "https://www.sunvinss.com/admin/upload/6.jpg", //
    description: `EAVER bestows software services to its customers and clients that alleviates the gap between Business and Technology.

    Our Software services include:

    • Web Development (PHP, Java, .Net)

    Our desire to fix up web related help to the clients so that they can contact in line with us perform well in search engines and deliver service for visitors.

    • Mobile Application Development (VB.Net, Java, Oracle)

    Facilitates to enhance our services by providing a new platform with new possibilities to customers by delivering unique experiences across all channels.

    • Desktop Application Development (Android, iOS)

    An easier way to get in touch with us for all services and products to value our customers with their needs and achieve better results.`,
  },
  {
    id: 7,
    title: "Electrical Services",
    image: img1, //
    description: `
    EAVER offers end-to-end electrical engineering solutions for power plants, substations, industrial facilities, and infrastructure projects. Our services ensure safe, reliable, and efficient operations across transmission, distribution, and industrial electrical systems up to 400 kV.

    We combine skilled manpower, advanced equipment, and proven methodologies to deliver high-quality services that reduce downtime, optimize performance, and enhance operational safety.

    Our Services
    1. Electrical Installation
    •	Installation of Transformers, LV Panels (PCC, MCC, APFC), VFD drives, motors, and switchgear
    •	Electrical works for power plants, substations, and industrial facilities
    •	Integration of control and instrumentation systems

    2. Testing & Commissioning
    •	High-voLVage testing up to 400 kV
    •	Relay testing using advanced OMICRON CMC 256 / 356 and DOBLE test sets
    •	Transformer, circuit breaker, and protection system testing
    •	Field services for substations, power plants, and industrial systems
    •	Preventive and breakdown maintenance

    3. Deputation of Electrical Testing Engineers & Equipment
    •	Skilled electrical testing engineers deputed on-site
    •	Supported with calibrated and advanced testing equipment
    •	Flexible deputation durations for short-term or long-term projects
    •	Assistance for relay testing, transformer testing, circuit breaker testing, and system commissioning
    
    4. Rental Testing Equipment
    •	Test Kits – OMICRON CPC 100, CMC 256 / 356, DOBLE Relay Test Sets
    •	Primary & Secondary Injection Test Sets
    •	Transformer Testing Equipment
    •	Circuit Breaker Analyzers
    •	Insulation Resistance & Hi-Pot Testers
    •	Earth Resistance & Soil Resistivity Testers
    •	Power Quality & Energy Analyzers
    `,
  }
  
];
export default services;
